import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { FormUnit, FormUnitProps } from './FormUnit';

const StyledWrapper = styled('div')({
  position: 'relative',
});

const StyledWrapperWithIcon = styled('div')({
  position: 'relative',
  color: 'red',
  '& .form-control': {
    paddingLeft: '2.5rem',
  },
});

const StyledIconWrapper = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '0.8rem',
  left: '0.8rem',
  color: theme.palette.grey[600],
  display: 'flex',
  alignItems: 'center',
}));

export type DecoratedFormUnitProps = FormUnitProps & {
  readonly icon?: React.ReactNode;
};

function FormIcon(p: { icon?: React.ReactNode }) {
  if (!p.icon) {
    return null;
  }

  return <StyledIconWrapper>{p.icon}</StyledIconWrapper>;
}

export function DecoratedFormUnit(props: DecoratedFormUnitProps) {
  const { icon, children, ...rest } = props;

  return (
    <FormUnit {...rest}>
      {icon ? (
        <StyledWrapperWithIcon>
          <FormIcon icon={icon} />
          {children}
        </StyledWrapperWithIcon>
      ) : (
        <StyledWrapper>{children}</StyledWrapper>
      )}
    </FormUnit>
  );
}
